import React, { Component } from 'react';
import PermissionsComponent from '../components/permissionsComponent';
import {getAllPermissionsSettings, addPermissionsData,
            deletePermissionsData, editPermissionsData} from '../action/permissionsAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

export class PermissionsContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getAllPermissionsSettings();
    }
    getPermissions= () =>{
        this.props.actions.getAllPermissionsSettings(
            this.props.dispatch
        )
    }
    updatePermissions = (formData) =>{
        this.props.actions.editPermissionsData(
            formData,
            this.props.dispatch
        )
    }
   getPermissionsData = () => {
          this.props.actions.getAllPermissionsSettings(this.props.dispatch);
       } 
    addPermissionsSetting = (formData) =>{
        this.props.actions.addPermissionsData(
            formData,
            this.props.dispatch
        )
    }
    deletePermissions = (itemId) => {
        this.props.actions.deletePermissionsData(
            itemId,
            this.props.dispatch
        )
    }
    render(){
        return(
            <div>
                <PermissionsComponent
                    PermissionsDetails = {this.props.PermissionsData}
                    addPermissions = {this.addPermissionsSetting}
                    deletePermissionsItem = {this.deletePermissions}
                    getPermissions ={this.getPermissions}
                    updatePermissions = {this.updatePermissions}
                    getPermissionsList={this.getPermissionsData}
                >
                </PermissionsComponent>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllPermissionsSettings,
            addPermissionsData,
            deletePermissionsData,
            editPermissionsData
        },
            dispatch)
    };
}
function mapStateToProps({ PermissionsReducer }) {
    console.log(PermissionsReducer);
    return {
        PermissionsData : {
            errorCode : PermissionsReducer.errorCode,
            statusCode : PermissionsReducer.statusCode,
            permissionsList : PermissionsReducer.permissionsList,
            message :PermissionsReducer.message,
            UpdatedList : PermissionsReducer.UpdatedList
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PermissionsContainer));